
export default function AffiliateDisclosure() {
  // Temporär ausgeblendet für Traffic-Test
  // TODO: Später wieder aktivieren für Affiliate-Programm
  return null;
}
